import {ID, Resource, TAG, ValidationMaxLength, ValidationRequired} from 'simpli-web-sdk'
import JornadaMotoristaSchema from '@/schema/JornadaMotorista.schema'

export default class JornadaMotorista extends Resource {
    get $schema() {
        return JornadaMotoristaSchema(this)
    }

    get $id() {
        return this.$id
    }

    set $id(val: ID) {
        this.$id = val
    }

    readonly $name: string = 'JornadaMotorista'

    readonly $endpoint: string = '/user/jornada-motorista{/id}'

    idMotoristaJornadaPk: ID = 0

    @ValidationRequired()
    @ValidationMaxLength(10)
    horaInicio: String  = ''

    @ValidationRequired()
    @ValidationMaxLength(5)
    horaFim: String  = ''

    @ValidationRequired()
    @ValidationMaxLength(5)
    rangeCepInicial: string = ''

    @ValidationRequired()
    @ValidationMaxLength(10)
    rangeCepFinal: string = ''

    @ValidationRequired()
    ativo: boolean = true

    @ValidationRequired()
    segunda: boolean = false

    @ValidationRequired()
    terca: boolean = false

    @ValidationRequired()
    quarta: boolean = false

    @ValidationRequired()
    quinta: boolean = false

    @ValidationRequired()
    sexta: boolean = false

    @ValidationRequired()
    sabado: boolean = false

    @ValidationRequired()
    domingo: boolean = false

    async validateJornadaDias() {
        return new Promise((resolve, reject) => {
            const array = [this.segunda, this.terca, this.quarta, this.quinta, this.sexta, this.sabado, this.domingo]
            if (array.includes(true)) resolve()
            reject()
        })
    }
}
